import styled from 'styled-components'

export const Container = styled.div`
`

export const Spacer = styled.div`
  height: 15vh;
  background: #fff;
`
